function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M480.195 0H0.124512V878.138H480.195V0Z",
  fill: "#D923D2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M331.457 313.119L340.316 337.436L354.603 334.003L480.265 383.389L480.051 661.57L480.199 878.14L0.128494 878.133L0.100875 774.09L0 670.02L0.178026 373.583L112.568 332.573L122.855 338.866L146.288 311.402",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M93.162 515.695L44.5049 357.48L62.6985 350.825L105.569 512.133L93.162 515.695Z",
  fill: "#7F00E2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M106.574 726.705L16.7359 878.14H0.128418L0.14142 867.337L95.6114 719.885L106.574 726.705Z",
  fill: "#E79D5F"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M384.641 729.746L480.185 866.818L480.205 878.14H469.662L373.601 736.439L384.641 729.746Z",
  fill: "#7F00E2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M370.341 511.785L413.612 357.176L431.105 364.078L382.704 515.492L370.341 511.785Z",
  fill: "#E79D5F"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M310.453 525.108H169.861C117.307 525.108 74.7043 567.76 74.7043 620.374V620.374C74.7043 672.988 117.307 715.641 169.861 715.641H310.453C363.007 715.641 405.61 672.988 405.61 620.374C405.61 567.76 363.007 525.108 310.453 525.108Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M125.861 552.211L112.143 510.376C110.444 505.197 104.873 502.374 99.699 504.07L95.6428 505.4C90.4687 507.096 87.6509 512.67 89.3492 517.849L103.068 559.684C104.766 564.863 110.337 567.686 115.511 565.989L119.568 564.66C124.742 562.963 127.559 557.39 125.861 552.211Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 5,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M113.919 685.954L90.423 723.175C87.5143 727.783 88.8871 733.88 93.4893 736.793L97.0971 739.076C101.699 741.989 107.788 740.614 110.697 736.007L134.193 698.785C137.102 694.177 135.729 688.081 131.127 685.168L127.519 682.885C122.917 679.972 116.828 681.346 113.919 685.954Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 5,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M345.049 699.621L368.566 736.832C371.477 741.439 377.567 742.81 382.169 739.896L385.776 737.611C390.377 734.696 391.747 728.599 388.836 723.992L365.319 686.781C362.408 682.175 356.318 680.803 351.717 683.718L348.109 686.003C343.508 688.917 342.138 695.014 345.049 699.621Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 5,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M373.92 559.638L387.09 517.628C388.721 512.427 385.831 506.887 380.637 505.255L376.564 503.976C371.37 502.343 365.837 505.236 364.206 510.437L351.036 552.448C349.405 557.649 352.295 563.188 357.489 564.82L361.562 566.1C366.756 567.732 372.289 564.839 373.92 559.638Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 5,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M240.159 690.751C278.121 690.751 308.896 659.941 308.896 621.935C308.896 583.928 278.121 553.118 240.159 553.118C202.196 553.118 171.421 583.928 171.421 621.935C171.421 659.941 202.196 690.751 240.159 690.751Z",
  fill: "#D923D2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M218.24 610.004L194.912 619.972L218.24 629.794L215.187 636.851L187.211 624.337V615.679L215.187 603.093L218.24 610.004Z",
  fill: "#F9FBFC"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M252.619 586.941L235.688 652.057L227.621 650.165L244.627 585.123L252.619 586.941Z",
  fill: "#F9FBFC"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M293.105 615.679V624.337L265.127 636.851L262.076 629.794L285.33 619.972L262.076 610.004L265.127 603.093L293.105 615.679Z",
  fill: "#F9FBFC"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M146.982 313.566C146.982 313.566 117.807 241.726 132.929 140.677C134.501 130.317 138.579 120.499 144.807 112.077C166.75 82.2885 225.257 23.4997 318.027 90.187C318.027 90.187 355.104 123.444 351.419 212.733C351.419 212.733 343.298 281.86 332.041 311.375C332.041 311.375 283.165 373.483 282.879 373.626C282.879 373.626 199.209 376.812 199.51 376.63C199.51 376.63 147.002 313.548 146.982 313.566Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M237.872 248.91C255.952 248.91 270.609 234.237 270.609 216.136C270.609 198.035 255.952 183.361 237.872 183.361C219.792 183.361 205.135 198.035 205.135 216.136C205.135 234.237 219.792 248.91 237.872 248.91Z",
  fill: "#FF073A"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M237.871 231.033C246.089 231.033 252.751 224.364 252.751 216.136C252.751 207.908 246.089 201.238 237.871 201.238C229.653 201.238 222.991 207.908 222.991 216.136C222.991 224.364 229.653 231.033 237.871 231.033Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M337.316 294.13L274.893 249.391L282.389 238.871L340.476 280.613L338.869 287.881L337.316 294.13Z",
  fill: "#E79D5F"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M191.839 190.752L131.905 147.999L132.927 140.467L133.54 137.204L134.25 134.066L138 136.747L199.334 180.232L191.839 190.752Z",
  fill: "#7F00E2"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M199.724 376.63L282.879 373.626L266.162 343.587L213.012 344.874L199.724 376.63Z",
  fill: "#FDFDFF"
});

function SvgMakersLeagueImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 879,
    viewBox: "0 0 481 879",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakersLeagueImage);
export default __webpack_public_path__ + "static/media/makers-league-image.17efa2b8.svg";
export { ForwardRef as ReactComponent };